// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class LoadContext {
    chatId: string;
    contactReason: string;
    uid: string;
    uui: string;
}